let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("92sUi"), load("i5RRW"), load("hPzOn"), load("a8Tkc")]).then(() => parcelRequire('48ZOK'));